import React, { useContext } from "react"
import Datetime from "react-datetime"
import "react-datetime/css/react-datetime.css"
import moment from "moment"
import "./date-picker.css"

function DatePicker({ setSelectedDate, setAdd }) {
  let yesterday = moment().subtract(1, "day")

  const handleDatePicker = (date) => {
    const selectedDate = date.format("YYYY-MM-DD")
    setSelectedDate(selectedDate)
    setAdd("Add")
  }
  const valid = (current) => {
    return current.isAfter(yesterday)
  }

  return (
    <div>
      <Datetime
        updateOnView={"days"}
        timeFormat={false}
        onChange={handleDatePicker}
        closeOnSelect={true}
        inputProps={{ placeholder: "Select a date" }}
        isValidDate={valid}
      />
    </div>
  )
}

export default DatePicker
